import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerModelliDichiarativiModalComponent } from './worker-modelli-dichiarativi-modal';

export const WorkerModelliDichiarativiModalModule: string = ng
    .module('worker-modelli-dichiarativi-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerModelliDichiarativiModalComponent', WorkerModelliDichiarativiModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-modelli-dichiarativi-modal/worker-modelli-dichiarativi-modal.module.ts